import type { SpacingScale } from '@meterup/atto';
import { sizing } from '@meterup/atto';

export const targetValues = {
  padding: {
    ends: { '@desktop': 4, '@notDesktop': 8 },
    sides: { '@desktop': 8, '@notDesktop': 12 },
  },
  borderRadius: { '@desktop': 8, '@notDesktop': 10 },
};

export const dockValues = {
  width: {
    maximized: {
      '@tablet': (220 + 12 + 12) as SpacingScale,
      '@desktop': (216 + 8 + 8) as SpacingScale,
    },
    minimized: {
      '@tablet': 52 as SpacingScale,
      '@desktop': 44 as SpacingScale,
    },
  },
  padding: {
    ends: { '@notDesktop': 12 as SpacingScale, '@desktop': 8 as SpacingScale },
    sides: { '@notDesktop': 12 as SpacingScale, '@desktop': 8 as SpacingScale },
  },
  dropdown: {
    '@tablet': 244 as SpacingScale,
    '@desktop': 204 as SpacingScale,
  },
  transition: {
    in: 'left 0.2s ease-in-out',
    inDelay: 0,
    out: 'left 0.2s ease-in-out',
    outDelay: '0.4s',
  },
};

export const applicationValues = {
  padding: {
    ends: sizing.secondary,
    sides: sizing.primary,
  },
  ends: {
    height: { '@desktop': 48, '@notDesktop': 52 },
  },
};
